import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getManufacturer = createAsyncThunk(
  "Manufacturer/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();

      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();

      const { data } = await axios.get(
        `${API_URL.MANUFACTURER.SLUG}?${queryString}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createManufacturer = createAsyncThunk(
  "Manufacturer/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.MANUFACTURER.SLUG}`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editManufacturer = createAsyncThunk(
  "Manufacturer/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${API_URL.MANUFACTURER.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteManufacturer = createAsyncThunk(
  "Manufacturer/delete",
  async (Id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${API_URL.MANUFACTURER.SLUG}/${Id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getManufacturerDetails = createAsyncThunk(
  "ManufacturerDetails/get",
  async (Id, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.MANUFACTURER.SLUG}/${Id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const manufacturerSlice = createSlice({
  name: "manufacturer",
  initialState: {
    manufacturer_list: [],
    current_values: null,
    active_payload: null,
    total_records: 0,
    manufacturer_detail: {},
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getManufacturer.fulfilled, (state, action) => {
        state.manufacturer_list = action.payload.data.list;
        state.total_records = action.payload.data.totalRecords || 0;
      })
      .addCase(getManufacturerDetails.fulfilled, (state, action) => {
        state.manufacturer_detail = action.payload;
      });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  manufacturerSlice.actions;
export default manufacturerSlice.reducer;
